import { Component, OnInit, Input, Output, EventEmitter, Renderer2, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { ConditionService, FormulaService } from '../../../services';

@Component({
  selector: 'sn-cell-field',
  templateUrl: './cell-field.component.html',
  styleUrls: ['./cell-field.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class CellFieldComponent implements OnInit {
    @Input() item:any;
    @Input() field:any;
    @Input() formulaResults:any;
    @Output() public onFieldBtnEvent = new EventEmitter();
    @Output() public onValueChangedEvent = new EventEmitter();
    @ViewChild('txtInput') txtIput: ElementRef;

    txt_value:string = "";
    value:any = "";
    cell_class:string = "";
    display_type:string = ""; 
    mode:string = "view";
    buttons:any[] = [];

    constructor(
        public conditionService: ConditionService,
        public formulaService: FormulaService,
    ) { }

    ngOnInit() {
        if (this.item && this.field) {
            this.value = this.getFieldValue();
            this.cell_class = this.field.cell_class;
            this.display_type = this.field.display_type;
            this.buttons = this.field.image_buttons;
        }
    }

    getFieldValue():any {
        var field_value = this.item[this.field.key];
        if (this.formulaResults && this.field.sn_calc_formula) {
            var fr = this.formulaResults.find(r => r.name == this.field.sn_calc_formula);
            if (fr) field_value = fr.result;
        }

        if (this.isFieldEditable() && !this.isShowEditIcon() && (field_value == null || field_value.length == 0)) {
            field_value = "--";
        }

        return field_value;
    }

    onBtnClick(btn) {
        this.onFieldBtnEvent.emit({ btn: btn, item: this.item, field: this.field });
        // switch (btn.event) 
        // {
        //     case "sn_open_modal_view": this.openModalView(btn); break;
        //     case "sn_open_modal_component": this.openModalComponent(btn); break;
        // }
    }

    isBtnVisible(btn) {
        var condResult = this.conditionService.getCondition(this.item.viewConditions, btn.sn_visible);
        return condResult ? condResult.result : true;
    }

    isFieldEditable() {
        //if (this.field.allow_edit) return true;
        var condResult = this.conditionService.getCondition(this.item.viewConditions, this.field.sn_allow_edit);
        return condResult ? condResult.result : this.field.allow_edit;
    }

    openModalView(btn) {
        
    }

    openModalComponent(btn) {

    }

    edit() {
        if (this.isFieldEditable()) {
            this.txt_value = this.item[this.field.key];  // use actual value over getFieldValue() to avoid processed values
            this.mode = "edit";
            // must set focus on timeout, otherwise, this.txtInput is undefined
            setTimeout(() => {
                this.txtIput.nativeElement.focus();
            },10);
        }
    }

    save() {
        var change = { };
        change[this.field.key] = this.txt_value;
        var event = { item: this.item, change: change };
        this.onValueChangedEvent.emit(event);
    }

    onFocusOut() {
        if (this.txt_value != this.item[this.field.key]) {
            this.save();
        }
        this.mode = "view";
    }

    isValueVisible() {
        var condResult = this.conditionService.getCondition(this.item.viewConditions, this.field.sn_value_visible);
        return condResult ? condResult.result : true;
    }

    isViewMode() { return this.mode == "view"; }
    isEditMode() { return this.mode == "edit"; }
    isShowEditIcon() { return this.isFieldEditable() && this.field.show_edit_icon; }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/common/cell-field/cell-field.component.ts